import { FC } from 'react';
import { IconProps } from './SatIcon';

const EnergyAuditIcon: FC<IconProps> = ({ id, fill, className }) => {
  return (
    <svg
      id={id}
      width="32"
      height="32"
      viewBox="0 0 31 30"
      fill={fill || 'none'}
      className={className}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.207 7.61719C23.7216 7.61719 23.3281 7.22367 23.3281 6.73828V0H10.7305C9.27658 0 8.09375 1.18283 8.09375 2.63672V12.4622C8.38332 12.436 8.67635 12.4219 8.97266 12.4219C11.9684 12.4219 14.6502 13.7916 16.425 15.9375H25.9648C26.4502 15.9375 26.8438 16.331 26.8438 16.8164C26.8438 17.3018 26.4502 17.6953 25.9648 17.6953H17.5829C18.1323 18.7673 18.4865 19.955 18.6003 21.2109H25.9648C26.4502 21.2109 26.8438 21.6045 26.8438 22.0898C26.8438 22.5752 26.4502 22.9688 25.9648 22.9688H18.6003C18.3374 25.8714 16.7865 28.4078 14.5249 30H28.3086C29.7625 30 30.9453 28.8172 30.9453 27.3633V7.61719H24.207ZM25.9648 12.4219H13.0742C12.5888 12.4219 12.1953 12.0284 12.1953 11.543C12.1953 11.0576 12.5888 10.6641 13.0742 10.6641H25.9648C26.4502 10.6641 26.8438 11.0576 26.8438 11.543C26.8438 12.0284 26.4502 12.4219 25.9648 12.4219Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M25.0854 0.515625V5.86037H30.4298L25.0854 0.515625Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M2.14483 22.4371C2.14483 20.3271 3.45096 18.5166 5.29703 17.771L6.239 15.8789C3.02785 16.3351 0.550293 19.102 0.550293 22.4371C0.550293 25.4715 2.60112 28.0357 5.38937 28.817L5.57054 27.2049C3.58121 26.5337 2.14483 24.65 2.14483 22.4371Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M13.7998 22.438C13.7998 19.4042 11.7498 16.8405 8.96254 16.0586L8.77728 17.6696C10.7678 18.3401 12.2052 20.2243 12.2052 22.438C12.2052 24.5358 10.9143 26.3374 9.08527 27.091L8.11719 28.9953C11.3253 28.5365 13.7998 25.771 13.7998 22.438Z"
        fill={fill || '#89AAEC'}
      />
      <path
        d="M10.9668 21.6349C11.0296 21.5114 11.0236 21.3757 10.9511 21.2576C10.8787 21.1395 10.75 21.0924 10.6114 21.0924H7.58072L8.23313 15.4204C8.25536 15.2282 8.13617 15.0289 7.9505 14.9738C7.91218 14.9625 7.87337 14.957 7.83505 14.957C7.68785 14.957 7.54873 15.0408 7.48021 15.1784L3.3816 23.414C3.32011 23.5375 3.32689 23.702 3.39954 23.8194C3.47224 23.9367 3.6004 24.0323 3.73848 24.0323H6.72919L6.11609 29.4907C6.09466 29.6823 6.2133 29.8434 6.39797 29.8986C6.43589 29.91 6.47431 29.913 6.51223 29.913C6.65913 29.913 6.79825 29.8315 6.86766 29.6949L10.9668 21.6349Z"
        fill={fill || '#89AAEC'}
      />
    </svg>
  );
};

export default EnergyAuditIcon;
